const {NotificationView} = require('./NotificationView');

module.exports = {NotificationView};



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/NotificationView/index.es6
 **/